import { createContext } from 'react';

export type RailzConnectCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  showConfirmUpdate: boolean;
  error: string;
  payableName: string;
  receivableName: string;
};

const RailzConnect = createContext<RailzConnectCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  showConfirmUpdate: false,
  error: '',
  payableName: '',
  receivableName: '',
});

export default RailzConnect;
